import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LocationDraftId = Brand<number, 'LocationDraftId'>;
export const LocationDraftId = createBranded<LocationDraftId>();